import { TableFilter } from '@/types/table';
import { capitalizeAll } from '@/utils/format';
import { MdOutlineFilterAlt } from 'react-icons/md';

interface AppliedFiltersProps {
    appliedFilters: Record<string, TableFilter<any>>;
    capitalize?: boolean;
}

const AppliedFilters = ({ appliedFilters, capitalize = true }: AppliedFiltersProps) => {
    return (
        <div className="flex overflow-auto items-center gap-2 text-xs">
            <span>
                <MdOutlineFilterAlt className="w-4 h-4" />
            </span>
            <div className="flex gap-2 h-6">
                {Object.keys(appliedFilters)
                    .filter((key) => appliedFilters[key].value && !appliedFilters[key].hidden)
                    .map((key) => (
                        <div
                            key={key}
                            className="flex items-center gap-2 p-1 px-2 font-normal text-brand-neutral-300 bg-brand-primary-darker rounded-sm whitespace-nowrap">
                            {appliedFilters[key].label}:{' '}
                            {capitalize ? capitalizeAll(appliedFilters[key].value) : appliedFilters[key].value}
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default AppliedFilters;
